import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LaunchpadAlV1Component } from './launchpad-al-v1/launchpad-al-v1.component';
import { LaunchpadHeadlineAlV1Component } from './launchpad-headline-al-v1/launchpad-headline-al-v1.component';
import { ForuPlusLogoModule } from 'abs-ngx-library/src/lib/foru-plus-logo';



@NgModule({
  declarations: [
    LaunchpadAlV1Component,
    LaunchpadHeadlineAlV1Component
  ],
  imports: [
    CommonModule,
    ForuPlusLogoModule
  ],
  exports: [
    LaunchpadAlV1Component,
    LaunchpadHeadlineAlV1Component
  ]
})
export class DealsHubModule { }
